import * as React from 'react'

import { observer } from 'mobx-react'

import filesStore from 'modules/documents/components/Documents/store'
import CommonFileList from 'modules/documents/components/FileList'

interface FileListProps {
  onDeleteFile: (i: number) => void
}

export const FileList = observer(({ onDeleteFile }: FileListProps) => {
  return <CommonFileList spaced={false} files={filesStore.files} onDeleteFile={onDeleteFile} />
})
